/* istanbul ignore file: this file does not contain any logic, only factory calls */

import { createLocalizationFactory, BaseOptions } from "@devowl-wp/utils";

// Only needed once per `window`
let FACTORY_MEMO;
function get() {
  return FACTORY_MEMO ? FACTORY_MEMO : FACTORY_MEMO = createLocalizationFactory(BaseOptions.getPureSlug(process.env.slug));
}
const _n = function () {
  return get()._n(...arguments);
};
const _nx = function () {
  return get()._nx(...arguments);
};
const _x = function () {
  return get()._x(...arguments);
};
const __ = function () {
  return get().__(...arguments);
};
const _i = function () {
  return get()._i(...arguments);
};
export { _n, _nx, _x, __, _i };